import { useEffect } from "react";
import SmoothScroll from "@/components/site/SmoothScroll";
import Navbar from "@/components/site/Navbar";
import MenuSection from "@/components/site/Menu";
import Footer from "@/components/site/Footer";

export default function MenuPage() {
  useEffect(() => {
    // Reset scroll to top on route entry
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, []);

  return (
    <SmoothScroll>
      <div data-testid="menu-page" className="bg-[#1C2541] min-h-screen">
        <Navbar />
        <main className="pt-20 md:pt-24">
          <MenuSection />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
